<template>
  <div>

    <template v-if="$store.state.editStatus !== 0">
      <Header v-if="!($route.path === '/login')"></Header>
    </template>
    <template v-if="$store.state.editStatus === 0">
      <EditHeader @release="release"></EditHeader>
    </template>

    <router-view v-if="isRouterAlive" />

    <!-- <div class="zxwt">
      <img v-if="$store.state.isMobile == 2 && bannerList.length > 0" class="zxwt" :src="bannerList[0].imgUrl" alt="" @click="onHttpUrl">
      <img v-if="$store.state.isMobile == 2 && bannerList.length == 0" class="zxwt" src="@/assets/img/zxwt.png" alt="" @click="onHttpUrl">
      <layout_mark style="z-index: 5000000;" v-if="$store.state.editStatus === 0" :type="16" :list="bannerList" @onReturn="bannerDate"></layout_mark>
    </div> -->
    <div class="optBg" v-if="$store.state.isMobile == 2">
      <div class="item">
        <img src="@/assets/img/feedback_native.png" alt="" class="native">
        <img src="@/assets/img/feedback_active.png" alt="" class="active">
        <span>意见反馈</span>
        <div class="customer">
          <img src="@/assets/img/customer_code.png" alt="">
          <span style="font-weight: normal;color: #000;">官方客服，欢迎咨询</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="item" style="cursor: pointer;" @click="onHttpUrl">
        <img src="@/assets/img/online_comm_native.png" alt="" class="native">
        <img src="@/assets/img/online_comm_active.png" alt="" class="active">
        <span>在线委托</span>
        <layout_mark style="z-index: 5000000;" v-if="$store.state.editStatus === 0" :type="16" :list="bannerList" @onReturn="bannerDate"></layout_mark>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import CopyRight from '@/components/CopyRight.vue';
import Icon from '@/components/Icon.vue';
import { release } from '@/api/public'
import { customRelease } from '@/api/pageTemplate'

import { banner } from '@/api/public'
export default {
  name: 'App',
  data() {
    return {
      path: '',
      isRouterAlive: true,
      bannerList: [],

    }
  },
  components: {
    Header,
    CopyRight,
    Icon,
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  mounted() {
    this.initMain()
    this.path = this.$route.path;
    this.handleResize();
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    initMain(event) {
      if (this.$store.state.isMobile == 2) {
        let whileData = '0'
        if (event) {
          whileData = event
        }
        if (whileData == '0' || whileData == '16') {
          banner({ isRelease: this.$store.state.editStatus, type: 16 }).then(res => {
            this.bannerList = res.data;
            if (res.data.length > 0) {
              setTimeout(() => {
                // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
              }, 100);
              this.$forceUpdate()
            }
          })

        }
      }
    },
    bannerDate(v, e) {
      if (e == '16') {
        this.bannerList = JSON.parse(JSON.stringify(v))
      }
      this.initMain(e)
      this.$forceUpdate()
    },
    handleResize() {
      let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (screenWidth < 768) {
        this.$store.commit('setIsMobile', 1)
      } else {
        this.$store.commit('setIsMobile', 2)
      }
    },
    pdfUrl(pdf) {
      let d = new Date()
      this.$router.push({ path: '/bdpdf', query: { name: pdf, t: d.getTime() } });

    },
    onHttpUrl() {
      if (this.bannerList.length > 0) {
        // window.open(`${this.bannerList.link}`, '_blank')
        window.open(`${this.bannerList[0].link}`, '_blank')

      } else {
        window.open('https://oaweb.dpark.com.cn/#/', '_blank')

      }
    },
    release(tag) {
      let route = this.$route.path;
      let type = '';
      //资讯
      if (route === '/news') {
        type = '1'
      }
      //产品与方案
      if (route === '/solutioNav') {
        type = '2'
      }

      //典型案例
      if (route === '/case') {
        type = '3'
      }
      if (route === '/caseMod') {
        type = '3'
      }
      //首页
      if (route === '/home') {
        type = '5'
      }
      //园测文化
      if (route === '/about') {
        type = '4'
      }
      //加入我们
      if (route === '/join') {
        type = '6'
      }
      //加入我们
      if (route === '/pageTemplate') {
        type = '7'
        let proProgrammeId = this.$store.state.proProgrammeId
        customRelease(proProgrammeId).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '发布成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '发布失败',
              type: 'error'
            });
          }

        })
        return
      }
      release({ type: type }).then(res => {
        this.$message.success('发布成功')
      })
      // 当更新首页时，可能在首页新增了资讯，需要再发布一下资讯动态
      // if (type = '5') {
      //   release({ type: '1' }).then(res => {
      //     this.$message.success('发布成功')
      //   })
      // }
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    }

  }
};
</script >

<style lang='scss' >
/* .zxwt {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  width: 182px;
  height: 100px;
} */
.optBg {
  position: fixed;
  bottom: 100px;
  right: 0;
  z-index: 999;
  width: 96px;
  height: 200px;
  background: url('~@/assets/img/opt_bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  > div {
    position: relative;
    top: -4px;
  }

  .line {
    width: 50%;
    height: 2px;
    background: #999999;
    margin: 0 auto;
  }

  .item {
    margin-left: 8px;
    width: 79%;
    height: 40%;
    display: flex;
    text-align: center;

    img {
      width: 34px;
      height: 34px;
      margin: 0 auto;
    }

    flex-direction: column;
    justify-content: center;

    .active {
      display: none;
    }

    .native {
      display: block;
    }

    span {
      color: #7e7f7e;
      font-size: 12px;
    }

  }

  .item:hover {
    .active {
      display: block;
    }

    .native {
      display: none;
    }

    span {
      color: #06387f;
      font-weight: 700;
    }

    .customer {
      display: block;

      img {
        width: 100%;
        height: 100%;
      }

      span {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 30px;
      }
    }
  }
}

.customer {
  width: 175px;
  height: 199px;
  display: none;
  position: absolute;
  bottom: 0;
  right: 70px;
}
</style>